import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./style.scss";

import { dataToJS, pathToJS, firebaseConnect } from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";

class Explore extends Component {
  constructor(props) {
    super(props);
    console.log("Explore", props);
    this.state = {
      showing: "hs-l"
    };
  }
  updateShowing(event) {
    this.setState({ showing: event.target.value });
  }
  componentWillMount() {}

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    console.log("Explore", props);
  }
  render() {
    if (
      this.props.group &&
      this.props.profile &&
      this.props.profile.role === "admin"
    )
      return (
        <div className="flex-container">

          <div className="toolbar">
            <DrawerToggle /> <h1>{this.props.group.name} Student Checklist</h1>
          </div>
          <div className="content log">
            <div className="page">
              <div className="max-width">
                <h1>
                  Showing:
                  <select
                    value={this.state.showing}
                    onChange={this.updateShowing.bind(this)}
                  >
                    <option value="hs-l">High School Students - Logs</option>
                    <option value="hs-s">High School Students - Survey</option>
                    <option value="u-l">Undergraduates - Logs</option>
                    <option value="u-s">Undergraduates - Survey</option>
                    <option value="ms-l">Medical Students - Logs</option>
                    <option value="ms-s">Medical Students - Survey</option>
                  </select>
                </h1>
                <div className="card no-padding">
                  <table>
                    <tbody>
                      <tr>
                        <th />
                        {this.props.logs &&
                          Object.keys(this.props.logs)
                            .map((key, id) => ({
                              ...this.props.logs[key],
                              _key: key
                            }))
                            .filter(
                              log =>
                                log.type ===
                                (this.state.showing.split("-")[1] === "l"
                                  ? "log"
                                  : "survey")
                            )
                            .sort((a, b) => a.order - b.order)
                            .map(log => (
                              <th key={log._key} className="rotate percentage">

                                <div>
                                  <span>
                                    <a
                                      href={
                                        `/print/group/${this.props.match.params.groupId}/log/${log._key}/role/${this.state.showing.split("-")[0] === "hs" ? "highschool" : this.state.showing.split("-")[0] === "u" ? "undergrad" : "gradstudent"}`
                                      }
                                      target="_blank"
                                    >
                                      {log.title}
                                    </a>
                                  </span>
                                </div>

                              </th>
                            ))}
                      </tr>
                      {this.props.group.students &&
                        this.props.percentage &&
                        Object.keys(this.props.group.students)
                          .map((key, id) => ({
                            ...this.props.group.students[key],
                            _key: key
                          }))
                          .filter(
                            student =>
                              student.role ===
                              (this.state.showing.split("-")[0] === "hs"
                                ? "highschool"
                                : this.state.showing.split("-")[0] === "u"
                                    ? "undergrad"
                                    : "gradstudent")
                          )
                          .sort((a, b) => {
                            if (a.lastName < b.lastName) return -1;
                            if (a.lastName > b.lastName) return 1;
                            return 0;
                          })
                          .map(student => (
                            <tr key={student._key}>
                              <td>
                                {student.firstName} {student.lastName}<br />
                                {student.email}
                              </td>
                              {Object.keys(this.props.logs)
                                .map((key, id) => ({
                                  ...this.props.logs[key],
                                  _key: key
                                }))
                                .filter(
                                  log =>
                                    log.type ===
                                    (this.state.showing.split("-")[1] === "l"
                                      ? "log"
                                      : "survey")
                                )
                                .sort((a, b) => a.order - b.order)
                                .map(log => {
                                  if (
                                    !this.props.percentage ||
                                    !student.uid ||
                                    !this.props.percentage.users[student.uid]
                                  )
                                    return <td key={log._key} />;
                                  return this.props.percentage.users[
                                    student.uid
                                  ].logs[log._key] &&
                                    this.props.percentage.users[
                                      student.uid
                                    ].logs[log._key].value
                                    ? <td
                                        key={log._key}
                                        className={
                                          !this.props.percentage.users[
                                            student.uid
                                          ].logs[log._key]
                                            ? "red"
                                            : this.props.percentage.users[
                                                student.uid
                                              ].logs[log._key].value == 1
                                                ? "green"
                                                : this.props.percentage.users[
                                                    student.uid
                                                  ].logs[log._key] &&
                                                    this.props.percentage.users[
                                                      student.uid
                                                    ].logs[log._key].value > 0
                                                    ? "yellow"
                                                    : "red"
                                        }
                                      >
                                        <a
                                          href={
                                            `/print/group/${this.props.match.params.groupId}/log/${log._key}/student/${student.uid}`
                                          }
                                          target="_blank"
                                        >
                                          {Math.round(
                                            !this.props.percentage.users[
                                              student.uid
                                            ].logs[log._key]
                                              ? "0"
                                              : this.props.percentage.users[
                                                  student.uid
                                                ].logs[log._key].value * 100
                                          ) + "%"}

                                        </a>
                                      </td>
                                    : <td key={log._key} className="red">
                                        <a
                                          href={
                                            `/print/group/${this.props.match.params.groupId}/log/${log._key}/student/${student.uid}`
                                          }
                                          target="_blank"
                                        >
                                          {" "}0%{" "}
                                        </a>
                                      </td>;
                                })}
                            </tr>
                          ))}

                    </tbody>
                  </table>
                </div>
                <p>
                  Note: If a cell is blank, the student has never logged in.
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    return (
      <div className="challenge-creator flex-container">
        <div className="toolbar">
          <DrawerToggle /><h1 />
        </div><BlankPage />
      </div>
    );
  }
}

export default withRouter(
  connect(({ firebase }, router) => {
    return {
      group: dataToJS(firebase, `/groups/${router.match.params.groupId}`),
      logs: dataToJS(firebase, `/logs`),
      auth: pathToJS(firebase, "auth"),
      profile: pathToJS(firebase, "profile"),
      percentage: dataToJS(
        firebase,
        `/percentages/groups/${router.match.params.groupId}`
      )
    };
  })(firebaseConnect(["/groups", "/logs", "/percentages"])(Explore))
);



// WEBPACK FOOTER //
// ./src/routes/group-dashboard/index.js